const GET_CONDITION = 'GET_CONDITION';
const SET_CONDITION = 'SET_CONDITION';

export
{
    GET_CONDITION,
    SET_CONDITION
};
